import useData from "../hooks/useData";
import { useEffect, useState } from "react";
import { getCmsTextList } from "../api/admin/cmsReq";

export default function MentionsLegales() {
    const [cmsTexts, setCmtTexts] = useState();

    const apiCmsTextList = async () => {
        const response = await getCmsTextList(3);
        if (!response?.error) {
            setCmtTexts(response?.data)
        } else {
            setCmtTexts([])
        }
    }

    useEffect(() => {
        document.title = "Mentions Légales - Obsèques en France";
        if (!cmsTexts) {
            apiCmsTextList()
        }
    }, [cmsTexts]);

    return (
        <div className="mentions-legales">
            <h1>Mentions légales et conditions<br />
                générales d'utilisation</h1>

            {cmsTexts?.filter(text => text?.enabled)?.map((text, index) => (
                <div key={index}>
                    <h2>{text?.hasTitle && text?.title}</h2>
                    <span>{text?.updatedAt}</span>
                    <div dangerouslySetInnerHTML={{ __html: text?.content }} />
                </div>
            ))

            }
        </div>
    )
}